import { defineAsyncComponent } from 'vue'

export default app => {
  app.component('PlatformForgotPasswordForm', defineAsyncComponent(() => import('./ForgotPasswordForm')))
  app.component('PlatformLoginForm', defineAsyncComponent(() => import('./LoginForm')))
  app.component('PlatformChemicalManagerLoginForm', defineAsyncComponent(() => import('./ChemicalManagerLoginForm')))
  app.component('PlatformRegisterForm', defineAsyncComponent(() => import('./RegisterForm')))
  app.component('PlatformResetPasswordForm', defineAsyncComponent(() => import('./ResetPasswordForm')))
  app.component('PlatformTwoFactorAuthChallenge', defineAsyncComponent(() => import('./TwoFactorAuthChallenge')))
  app.component('PlatformCreateOrganisationForm', defineAsyncComponent(() => import('./CreateOrganisationForm')))
  app.component('PlatformLoginOptions', defineAsyncComponent(() => import('./LoginOptions')))
}
